export default "__VITE_ASSET__CD6stayv__"